import { useState } from 'react'

const THEME_OPTIONS = ['light', 'dark', 'system']

export const ThemeTestToggle = ({ theme }) => {
  const [currentMode, setCurrentMode] = useState(() => theme.getMode())

  const handleThemeChange = (mode) => {
    if (theme.setMode(mode)) {
      setCurrentMode(mode)
    }
  }

  return (
    <div
      role="group"
      aria-label="테마 설정"
      className="fixed right-16 bottom-16 z-[9999] flex rounded-full bg-white p-2 shadow-lg"
    >
      {THEME_OPTIONS.map((mode) => {
        const isActive = currentMode === mode

        return (
          <button
            key={mode}
            type="button"
            aria-pressed={isActive}
            onClick={() => handleThemeChange(mode)}
            className={
              isActive
                ? 'rounded-full bg-black px-10 py-1 text-white'
                : 'rounded-full px-10 py-1 text-gray-500'
            }
          >
            {mode}
          </button>
        )
      })}
    </div>
  )
}
